<template>
  <v-row class="fill-height" no-gutters>
    <v-col class="d-flex flex-column">
      <div>
        <navigation-header class="px-0" title="Szkolenia i testy"></navigation-header>
      </div>
      <div class="flex-grow-1 d-flex justify-center align-center">
        <fp-loader v-if="loading"
                   circle
                   size="120px" />
        <div v-else class="pb-16 mt-3">
          <div v-if="AuthService.User?.quiz?.requireEthic || !!lastPositiveAttempt">
            <quiz-card :last-positive-attempt="lastPositiveAttempt ?? undefined" :category="QuizCategory.ETHIC"/>
          </div>
          <div v-else class="text-center d-flex flex-column justify-center align-center gap-3">
            <v-img :src="require('@/assets/icons/quizes/no_statements.svg')" width="99" height="62"></v-img>
            <span class="headline-3">
              Nie masz żadnych szkoleń
              <br />
              do zaliczenia
            </span>
          </div>
        </div>
      </div>
     </v-col>
   </v-row>
</template>
<script setup lang="ts">
import HumanResourcesApi from '@/modules/adminPanel/services/HumanResourcesApi';
import { QuizTest, QuizTestAttempt } from '@/modules/bhp/models/QuizTest';
import { onMounted, ref } from 'vue';
import { QuizCategory } from '@/models/Quiz';
import QuizCard from '@/modules/Statements/components/QuizCard.vue';
import AuthService from '@/modules/user/AuthService';
import QuizCardSuccess from '@/modules/Statements/components/QuizCardSuccess.vue';
import { useInstance } from '@/composables/useInstance';
import { useModal } from '@/components/L/Modal/useModal';
import NavigationHeader from '@/components/NavigationHeader/NavigationHeader.vue';

const loading = ref<boolean>(false);
const quizzes = ref<QuizTest[]>([]);
const lastPositiveAttempt = ref<Nullable<QuizTestAttempt>>(null);
const { $route, $modalService, $router } = useInstance();
const {openModal,} = useModal();

const getLatestResultsForCurrentUser = async () => {
  try {
    loading.value = true;
    const result = await HumanResourcesApi.getLatestResultForCurrentUser(QuizCategory.ETHIC);
    if (result) {
      lastPositiveAttempt.value = result;
    }
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

const getNewestQuizTestQuestions = async () => {
  try {
    const quiz = await HumanResourcesApi.getNewestQuizTestQuestions(QuizCategory.ETHIC);
    quizzes.value = quiz ? [quiz] : [];
  } catch (e) {
    console.error(e);
  }
};


onMounted(async () => {
  await getLatestResultsForCurrentUser();
  await getNewestQuizTestQuestions();
  
  if ($route.value?.query.ethic) {
      $router.value?.push({query: {ethic: undefined,},})
    if (lastPositiveAttempt.value) {
      await openModal(QuizCardSuccess, {
        lastPositiveAttempt: lastPositiveAttempt.value!,
        quizCategory: QuizCategory.ETHIC
      });
    }
  }
});
</script>

<style scoped lang="scss">
</style> 